export default "__VITE_ASSET__CorE_R_G__"